import { message } from "antd";

const hardcodeToken = "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJiZWEwODRmMS1iOWI0LTQ2ZGEtYjZiZi1kNDg1YjE2YWJjZGQiLCJuYW1lIjoiQXJlZWogWmFoaWQgQWxpIiwiaW1hZ2UiOiJodHRwczovL3dvcmt3LmNvbS9SZXNvdXJjZXNcXDBhYjVmOWMwLWY5NDgtNGM0MC04ZGFkLWM1OGJhOTlmYjc2NVxcSW1hZ2VzXFxiZGM2YmM1NC0wNjAwLTQxOGYtYTM0OS1mMDIyMWRhYjU2MGYuanBlZyIsImVtYWlsIjoiYXJlZWpAbWlsZXRhcC5jb20iLCJidXNpbmVzc0lkIjoiMGFiNWY5YzAtZjk0OC00YzQwLThkYWQtYzU4YmE5OWZiNzY1IiwidmVyIjoiODIzODlFQkMtMDA1OS00NEUzLUI1QjUtMUM0REU0NzcwQ0E1IiwiaWgiOiJqeDB5N0QreXRxU25EZVZwbFJzWFhaM294ZUFTYXNCYnNCZjkwR1ljNlNjPSIsImlzIjoiZ1RqMEEvdFZReGkrU1g5MEhwNUhuZz09IiwicGgiOiJCV0VVWTFLUWc1NmR0allaY2RFSURMQVJpeGp0MUlhRmNKd01CUEFPWEtJPSIsInBzIjoiMUx6UW5NdU95RmY2MXBNWXJkREh3dz09IiwiaXNBZ2VudCI6IkZhbHNlIiwianRpIjoiNjJmYzVjNmYtZmMzZi00OGViLWJmMzgtZTNkNWViYmFlZjNmIiwibmJmIjoxNzcxNTY2MjY5LCJleHAiOjE3NzE3MzkwNjl9.CQdyXgfWtai2WTx4kuirt8nRzZffAWXD6MfwQEJQj8gG9QhMo14NYVh0MSOJMh2AB7ySMUu5N_UBeM93vNSAD065yxOEkREJFgJFOQZGcCvaDdmpwBJoND4tU6du_lM0T_1xNQLspMqYVTN2DQ5dfMzs9q_k-9zq2XoTyhqBOZep6UUATOdIIB6Wtx48QDqR7b7SPNuRPYeKQJPkMn3GBfkv5NAc_i1PjH1gb15OXZborQNRinkWgjrr9rVz-TfDqA5ElTLUkWrsMQbraBsvoYKVsCbb-gkkAC5ZSxokhzRqgQoOuhsEInACNZEyz_c_KQVJ55nlsfIz7kJZ1QS_Rw";

function getCookieValue(name) {
  const regex = new RegExp(`(^| )${name}=([^;]+)`)
  const match = document.cookie.match(regex)
  if (match) {
    return match[2]
  }
}

export function getWorkWiseAuthToken() {
  const searchParams = new URLSearchParams(document.location.search);
  let cookieToken = getCookieValue('token');
  let queryToken = searchParams.get("token");
  const finalToken = queryToken || cookieToken || hardcodeToken;
  return finalToken;
}
export const formatFileSize = (bytes) => {
  if (bytes === 0) return "0 Bytes";

  const units = ["Bytes", "KB", "MB", "GB"];
  let size = bytes;
  let unitIndex = 0;

  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex++;
  }

  if (unitIndex === 0) {
    return `${size} ${units[unitIndex]}`;
  } else if (unitIndex === 1 && size < 50) {
    return `${parseFloat(size.toFixed(0))} ${units[unitIndex]}`;
  } else {
    return `${parseFloat(size.toFixed(2))} ${units[unitIndex]}`;
  }
};
export const isRespectiveDocument = (documentId) => {
  const pathname = window.location.pathname;
  const id = pathname.split("/")[1];
  return id && id === documentId;
};


export const getWatermarkData = async () => {
  const now = new Date();
  const currentDateTime = now.toLocaleString();

  // Get IP address
  let ip = 'N/A';
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    ip = data.ip;
  } catch (error) {
    console.error("Error fetching IP:", error);
    message.error("Could not fetch IP address");
  }

  // Get location
  let location = { lat: 'N/A', lng: 'N/A' };
  try {
    location = await new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        message.error("Geolocation not supported");
        return resolve(location);
      }

      navigator.geolocation.getCurrentPosition(
        (position) => resolve({
          lat: position.coords.latitude,
          lng: position.coords.longitude
        }),
        (error) => {
          handleGeolocationError(error);
          resolve(location); // Return default on error
        }
      );
    });
  } catch (error) {
    console.error("Location error:", error);
  }

  return {
    currentDateTime,
    ip,
    location
  };
};

const handleGeolocationError = (error) => {
  switch (error.code) {
    case error.PERMISSION_DENIED:
      message.error("Location access denied. Please enable permissions.");
      break;
    case error.POSITION_UNAVAILABLE:
      message.error("Location information unavailable.");
      break;
    case error.TIMEOUT:
      message.error("Location request timed out.");
      break;
    default:
      message.error("Unknown location error occurred.");
  }
};

export const processTemplateData = (serverResponse) => {
  let templateData = serverResponse?.data?.data || null;
  if (templateData?.milepadData) {
    try {
      const rawData = JSON.parse(templateData.milepadData);
      delete templateData.milepadData;
      templateData.mindmapData = rawData;
    } catch (error) {
      console.error('Failed to parse template milepadData:', error);
      delete templateData.milepadData;
      templateData.mindmapData = {};
    }
  }
  return templateData;
};

export const removeTemplateIdFromURL = (history) => {
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.delete('templateId');
  const newSearch = searchParams.toString();
  // If a history-like object with replace is provided, use it (react-router v6 compatibility).
  if (history && typeof history.replace === 'function') {
    history.replace({
      pathname: window.location.pathname,
      search: newSearch ? `?${newSearch}` : ''
    });
    return;
  }

  // Fallback: use the browser history API to replace the current URL without reloading.
  try {
    const newUrl = window.location.pathname + (newSearch ? `?${newSearch}` : '');
    if (window.history && typeof window.history.replaceState === 'function') {
      window.history.replaceState(null, '', newUrl);
    }
  } catch (err) {
    console.error('Failed to remove templateId from URL:', err);
  }
};

export const createUpdatePayload = (type, data) => {
  switch (type) {
    case 'position':
      return { position: data };
    case 'name':
      return { data: { label: data } };
    case 'style':
      return { style: data };
    case 'properties':
      return {
        data: {
          label: data.label,
          nodeBg: data.nodeBg,
          textBg: data.textBg,
        },
        type: data.type
      };
    case 'color':
      return data; // For updateMany, payload is the nodes array
    default:
      return data;
  }
};

export const updateFileSize = (data, setSavingData) => {
  try {
    const size = new TextEncoder().encode(JSON.stringify(data)).length || 0;
    setSavingData({
      isSaving: "",
      lastSavedDateTime: "",
      fileSize: formatFileSize(size),
    });
  } catch (error) {
    console.error('Failed to calculate file size:', error);
    setSavingData({
      isSaving: "",
      lastSavedDateTime: "",
      fileSize: formatFileSize(0),
    });
  }
};